import React from 'react';
import { Icon, Text } from '../../Atoms';
function MoleculeDetailDocument (props) {
  return (
    <div className='container-molecule-document'>
      <div className='container-description-doc'>
        <Text
          text={props.type}
          className='txt-description-doc'
          loader={false}
        />
        <Text
          text={props.amount}
          className='txt-description-doc'
          loader={false}
        />
      </div>
      <div className='molecule-document'>
        <Icon icon='Doc' size='22px' className='icon-document' />
        <div className='container-text-detail-doc'>{props.text}</div>
        <div className='container-icons-detail-doc'>
          <Icon style={{cursor: 'pointer'}} icon='Eyes' size='20px' onClick={props.onViewFile} />
          <Icon
           style={{cursor: 'pointer'}}
            icon='Telechargement'
            size='22px'
            color='#1313C6'
            onClick={props.onDownload}
          />
        </div>
      </div>
    </div>
  );
}
MoleculeDetailDocument.defaultProps = {
  text: null,
  type: null,
  amount: null,
  onViewFile: null,
  onDownload: null
};
export default MoleculeDetailDocument;
